import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class TableTextAreaInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        return (
            <div className="w-100 h-100 flexcc text-start">
                <p className="" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{this.props.data!=null ? (String(this.props.data).substr(0,40)+(String(this.props.data).length>40?' ...':'')):' '}</p>
            </div>
        )
    }
}

export default TableTextAreaInput;